/**
 * Returns the appropriate API URL based on execution context.
 */
export function getApiUrl(): string {
  const apiUrl = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000';
  if (globalThis.window === undefined) return apiUrl;
  // Cookies are scoped to hosts, so localhost can use separate frontend/API ports.
  return new URL(apiUrl).hostname === globalThis.window.location.hostname
    ? apiUrl
    : globalThis.window.location.origin;
}
